export { default } from './FooterDesktop';